import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const state = {
    // 初始化数据，等待获取
    userId: ''
}
const mutations = {
    userIdlist(state, data) {
        state.userId = data
    },
}


export default new Vuex.Store({
    state,
    mutations
    // etc
})


// WEBPACK FOOTER //
// ./src/store/index.js